module.exports = __webpack_public_path__ + "img/other_realme3.d1542227.jpg";